import { render, staticRenderFns } from "./GiftProgressSubmenu.vue?vue&type=template&id=676089af&"
import script from "./GiftProgressSubmenu.vue?vue&type=script&lang=js&"
export * from "./GiftProgressSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports